module.exports = __webpack_public_path__ + "static/img/usBottom8.1f82a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/usBottom8.png
// module id = MBFc
// module chunks = 2